"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfJurisdictionDetailsDto = instanceOfJurisdictionDetailsDto;
exports.JurisdictionDetailsDtoFromJSON = JurisdictionDetailsDtoFromJSON;
exports.JurisdictionDetailsDtoFromJSONTyped = JurisdictionDetailsDtoFromJSONTyped;
exports.JurisdictionDetailsDtoToJSON = JurisdictionDetailsDtoToJSON;
exports.JurisdictionDetailsDtoToJSONTyped = JurisdictionDetailsDtoToJSONTyped;
const NurseLicenseCompactDto_1 = require("./NurseLicenseCompactDto");
/**
 * Check if a given object implements the JurisdictionDetailsDto interface.
 */
function instanceOfJurisdictionDetailsDto(value) {
    if (!('abbreviation' in value) || value['abbreviation'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('nurseLicenseCompacts' in value) || value['nurseLicenseCompacts'] === undefined)
        return false;
    return true;
}
function JurisdictionDetailsDtoFromJSON(json) {
    return JurisdictionDetailsDtoFromJSONTyped(json, false);
}
function JurisdictionDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'abbreviation': json['abbreviation'],
        'name': json['name'],
        'nurseLicenseCompacts': (json['nurseLicenseCompacts'].map(NurseLicenseCompactDto_1.NurseLicenseCompactDtoFromJSON)),
    };
}
function JurisdictionDetailsDtoToJSON(json) {
    return JurisdictionDetailsDtoToJSONTyped(json, false);
}
function JurisdictionDetailsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'abbreviation': value['abbreviation'],
        'name': value['name'],
        'nurseLicenseCompacts': (value['nurseLicenseCompacts'].map(NurseLicenseCompactDto_1.NurseLicenseCompactDtoToJSON)),
    };
}
//# sourceMappingURL=JurisdictionDetailsDto.js.map